











































import Vue from "vue";
import Page from "../../../components/Page.vue";
import configuration, {AppConfiguration} from "@/models/Configuration";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import IconButton from "@/components/IconButton.vue";
import GeneralIngoingInvoiceApi from "../services/GeneralIngoingInvoiceApi";
import { t } from "@/plugins/i18n";

interface Data {
  configuration: AppConfiguration;
  importItemsInTable: any;
}

interface Methods {
  importItems(items: any): void;
  refreshApiSearch(): void;
  updateInvoice(item: any): void;
  deleteInvoice(item: any): void;
}

interface Computed {
  columns: ApiSearchColumn[];
}

export default Vue.extend<Data, Methods, Computed, {}>({
  data() {
    return {
      configuration,
      importItemsInTable: [],
    };
  },

  components: {
    Page,
    ApiSearchPage,
    IconButton
  },

  methods: {
    importItems(items: any){
      this.importItemsInTable = items;
    },

    deleteInvoice(item){
      if (item.isLoading) {
        return;
      }

      item.isLoading = true;

      GeneralIngoingInvoiceApi.deleteInvoice(item.importId).then(() => { this.refreshApiSearch() }).finally(() => { item.isLoading = false; });
    },

    refreshApiSearch() {
      const childComponentInstance = this.$refs.asref;
      if (childComponentInstance) {
        (this.$refs.asref as any).refreshClick();
      }
    },

    updateInvoice(item: any) {
      const path = configuration.invoiceFlow.enabled
        ? `/general-incoming-invoice/flow/edit/${item.invoiceID}/2`
        : `/general-incoming-invoice/edit/${item.invoicePartner}/${item.invoiceID}`;

      this.$router.push(path);
    },
  },

  watch: {

  },

  computed: {

    columns: (): ApiSearchColumn[] => [
      {
        title: t("Szamlaszam"),
        field: "invoiceID",
        cell: "geniID",
      },
      {
        title: t("KulsoSzamlaszam"),
        field: "invoiceNo",
      },
      {
        title: t("GeneralIngoingInvoice_HivatkozottKulsoSzamlaSzama"),
        field: "originalInvoiceNo",
      },
      {
        title: t("SzamlaDatuma"),
        field: "invDate",
        type: ColumnType.Date
      },
      {
        title: t("TeljesitesDatuma"),
        field: "deliveryDate",
        type: ColumnType.Date
      },
      {
        title: t("FizetesiMod"),
        field: "paymentMode",
      },
      {
        title: t("FizetesiHatarido"),
        field: "payDate",
        type: ColumnType.Date
      },
      {
        title: t("Penznem"),
        field: "currency",
      },
      {
        title: t("GeneralIngoingInvoice_SzallitoNeve"),
        field: "supplierName",
      },
      {
        title: t("SzallitoAdoszama"),
        field: "supplierTaxNo",
      },
      {
        title: t("Netto"),
        field: "netto",
        type: ColumnType.Money,
        filterable: false,
        sortable: false,
      },
      {
        title: t("AFA"),
        field: "vat",
        type: ColumnType.Money,
        filterable: false,
        sortable: false,
      },
      {
        title: t("Brutto"),
        field: "brutto",
        type: ColumnType.Money,
        filterable: false,
        sortable: false,
      },
      {
        title: "",
        field: "importID",
        cell: "delete",
        filterable: false,
        sortable: false,
      },
    ],
  },
});
